import { render, staticRenderFns } from "./index-nor.vue?vue&type=template&id=f12682ec"
import script from "./index-nor.vue?vue&type=script&lang=tsx"
export * from "./index-nor.vue?vue&type=script&lang=tsx"
import style0 from "./index-nor.vue?vue&type=style&index=0&id=f12682ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports